import DisplayRecorder from "./DisplayRecorder";

import { useEffect, useState } from "react";



const ListenAndSpeak = ({tracks, resultsHandler, nextTab, nextExercise, progress, setProgress, tab}) => {
    const [isgranted, setIsGranted] = useState(false)
    const [media, setMedia] = useState()

    const getMicrophonePermission = async () => {
        if ("MediaRecorder" in window) {
            try {
                const streamData = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                setIsGranted(true);
                setMedia(streamData)
                
                
            } catch (err) {
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }
    };
    // console.log(tracks, "tracks LS")
   

    useEffect(() => {
        if (navigator) {
        navigator.permissions
            .query({ name: "microphone" })
            .then(async function (result) {
            if (result.state === "granted") {

                //If granted then you can directly call your function here
            
                if ("MediaRecorder" in window) {
                    try {
                        const streamData = await navigator.mediaDevices.getUserMedia({
                            audio: true,
                            video: false,
                        });
                        setIsGranted(true);
                        setMedia(streamData)
                        
                        
                    } catch (err) {
                        alert(err.message);
                    }
                } else {
                    alert("The MediaRecorder API is not supported in your browser.");
                }
            } else if (result.state === "prompt") {
                //If prompt then the user will be asked to give permission
                console.log(prompt)
               
            } else if (result.state === "denied") {
                //If denied then you have to show instructions to enable location
            }
            });
        } else {
        console.log("navigator is not supported by this browser.");
        }
    }, []);

    
    
    return (
        
        <>
        { isgranted ?
        <DisplayRecorder    stream={media} 
                            tracks={tracks} 
                            resHandler={(state) =>
                                {
                                resultsHandler(state)
                                    

                                
                                } 
                            } 
                            nextTab = {(state) =>
                            {
                                nextTab(state)
                            }}
                            nextExercise = {nextExercise}

                            progress={progress}
                            setProgress={setProgress}
                            tab={tab}
                            
        />
        :
        <div className="m-auto flex max-w-md flex-col items-center rounded-2xl border border-slate-200 bg-slate-50 p-7 text-center">

            <p className="font-bold text-cyan-950">Enable your microphone for this exercise.</p>
            <p className="mt-2 text-sm text-slate-500">Your recording stays in the browser and is used for playback comparison.</p>

            <button className="mt-5 rounded-xl bg-[#176b87] px-5 py-3 font-bold text-white shadow-md transition hover:bg-[#0f5269]" onClick={getMicrophonePermission} type="button">
            Enable microphone
            </button>

        </div>

        }
        </>
    )

}

export default ListenAndSpeak;
